module.exports = __webpack_public_path__ + "img/mb-signout-2.ae780870.svg";